<template>
    <el-popover title="预算单选择" width="1000" v-model="visible" v-bind="this.$attrs" v-on="this.listeners" trigger="click" class="popover">
        <el-input
            class="display"
            slot="reference"
            :value="headerCode"
            readonly="readonly"
            :placeholder="placeholder"
            :disabled="this.$attrs.disabled"
            :size="size"
        ></el-input>
        <div v-if="poiId">
            <div class="table">
                <xx-search-form v-model="searchParams" :fields="searchFormFields" @submit="search" @reset="reset"></xx-search-form>
                <xx-table-pro
                    name="table"
                    ref="table"
                    :autoLoad="true"
                    :buildParams="buildParams"
                    :responseProcessor="responseProcessor"
                    :ajax="ajax"
                    :highlight-current-row="true"
                    :pagination="pagination"
                    @current-change="currentRowChange"
                    :height="170"
                    :columns="columns"
                >
                    <template slot="select" slot-scope="scope">
                        <el-checkbox v-model="scope.row.checked"></el-checkbox>
                    </template>
                </xx-table-pro>
            </div>
            <div style="text-align: right; padding-top: 10px">
                <el-button size="mini" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="confirm">确定</el-button>
            </div>
        </div>
        <div v-else>
            <div class="no-poi">请先选择门店/DC</div>
        </div>
    </el-popover>
</template>

<script>
export default {
    name: 'XxBudgetinfoSelect',
    props: {
        size: {
            type: String,
            default: 'small'
        },
        value: {
            type: [String, Object],
            default: () => ({})
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        poiId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            visible: false,
            searchParams: {
                headerCode: '',
                secondSkuId: ''
            },
            searchFormFields: [
                {
                    label: '预算申请单号',
                    model: 'headerCode'
                },
                {
                    label: '二级品类',
                    model: 'secondSkuId',
                    template: {
                        tpl: 'xx-category-select',
                        attrs: {
                            maxLevel: 2,
                            selectLevel: 2,
                            multiple: false,
                            placeholder: '请选择品类'
                        }
                    }
                }
            ],
            columns: [
                { label: '', prop: 'select', minWidth: 20 },
                { prop: 'headerCode', label: '预算申请单号', minWidth: 120 },
                { prop: 'secondSkuName', label: '二级品类', minWidth: 80 },
                { prop: 'totalAmount', label: '预算金额', minWidth: 70 },
                { prop: 'expendAmount', label: '(占用+耗用）金额', minWidth: 70 },
                { prop: 'surplusAmount', label: '剩余金额', minWidth: 70 }
            ],
            pagination: {
                show: true,
                pageSizes: [5, 10],
                pageSize: 5
            },
            selectedRow: {},
            headerCode: (this.value && this.value.headerCode) || ''
        };
    },
    computed: {
        ajax() {
            return {
                url: `${window.location.origin}/api/m/fbs/queryBudgetDetailList`,
                params: {
                    ...this.searchParams,
                    poiId: this.poiId
                }
            };
        },
        listeners() {
            const { input, ...others } = this.$listeners;
            return others;
        }
    },
    watch: {
        value: {
            deep: true,
            handler(v) {
                this.selectedRow = v;
                this.headerCode = v.headerCode || '';
            }
        },
        async poiId() {
            await this.$nextTick();
            this.search();
        }
    },
    methods: {
        buildParams(params, tableParams) {
            params.offset = tableParams.paging.offset;
            params.limit = tableParams.paging.limit;
            return params;
        },
        responseProcessor(res) {
            const data = (res.responses || []).map(item => {
                return {
                    ...item,
                    expendAmount: this.$tools.minus(item.totalAmount, item.surplusAmount),
                    checked: false
                };
            });
            return {
                data,
                total: res.total || 0
            };
        },
        fetchData() {
            this.$refs.table && this.$refs.table.queryData();
        },
        search() {
            this.fetchData();
        },
        async reset() {
            this.searchParams = {};
            await this.$nextTick();
            this.search();
        },
        currentRowChange(row) {
            this.selectedRow && (this.selectedRow.checked = false);
            this.selectedRow = row;
            row && (row.checked = true);
        },
        confirm() {
            this.visible = false;
            this.headerCode = (this.selectedRow && this.selectedRow.headerCode) || '';
            this.$emit('input', this.selectedRow || {});
            this.$emit('select', this.selectedRow || {});
            this.selectedRow = {};
            this.reset();
        }
    }
};
</script>

<style lang="scss" scoped>
.display {
    width: 198px;
    outline: none !important;
}
.no-poi {
    color: #999;
    text-align: center;
    padding: 30px 0;
}
.table {
    /deep/ {
        .el-table tr {
            cursor: pointer;
        }
        .el-table__body tr.current-row:hover > td {
            background-color: #ecf5ff;
        }
    }
}
</style>
